<template>
    <div>
        简报专刊
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="sass" scoped>

</style>